const isBillesByName = group => {
  return group === 'Billes'
}

export default isBillesByName



// WEBPACK FOOTER //
// ./src/utils/isBillesByName.js